export var handleForHiddenIpad = function() {
    (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) ? $(".hidden-ipad").addClass('hidden'): $(".hidden-ipad").removeClass('hidden');
};
